{"id":"Modal.Content","prefabs":{"default":{"children":[{"component":"Modal.Content","options":"options:*"}]}}}